const userLoginValidate = (userId, password, i18n) => {
  let error = ''
  if (!userId.trim().length) {
    error = i18n.t('validate.login.msgValidateId')
    return {
      validate: false,
      error,
    }
  }
  if (!password.trim().length) {
    error = i18n.t('validate.login.msgValidatePassword')
    return {
      validate: false,
      error,
    }
  }
  return {
    validate: true,
    error,
  }
}

export default userLoginValidate
